module.exports = __webpack_public_path__ + "media/images/ac_templates/201/kly-6511665838915c80df0b42924a82fda9.jpg";